<template>
  <section>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      labelWidth="120px"
      :formData="formData"
    />
  </section>
</template>

<script>
export default {
  props: {
    cardNum: {
      type: String,
      default: '',
    },
    cardTypeName: {
      type: String,
      default: '',
    },
    cardBalance: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      formData: {
        form: [
          {
            label: '油卡卡号',
            value: 'cardNum',
            type: 'input',
            default: this.cardNum,
            placeholder: '请输入油卡卡号',
            readonly: true,
          },
          {
            label: '油卡类型',
            value: 'cardTypeName',
            type: 'input',
            default: this.cardTypeName,
            placeholder: '请输入油卡类型',
            readonly: true,
          },
          {
            label: '理论余额',
            value: 'cardBalance',
            type: 'input',
            default: this.cardBalance,
            placeholder: '请输入理论余额',
            readonly: true,
          },
        ],
      },
    };
  },
  watch: {
    cardBalance (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$refs.baseForm.setVal('cardBalance', newValue);
      }
    },
  },
};
</script>

<style>
</style>
